import React, { memo, useCallback, useEffect } from 'react';

import { NavBar, I18n, Navigation } from '../components';
import { __WEB__ } from '../../constants/styles';

import { useSelector, useDispatch } from 'react-redux';

import { getEditingCaseMedicalTeamParticipants } from './selector';
import { updateMedicalTeamParticipants } from './actions';

import List from './list';

export default memo((props) => {
  const dispatch = useDispatch();
  const medicalTeam = useSelector(getEditingCaseMedicalTeamParticipants);
  const editingCaseId = useSelector((state) => state.screens.cases.caseInfoCaseId);

  useEffect(
    NavBar.setup(
      props,
      !__WEB__ &&
        props.asModal && {
          buttons: { leftButtons: [NavBar.buttons.done] },
        }
    ),
    []
  );

  const addMedicalTeam = useCallback(() => {
    Navigation.push(
      {
        screen: 'MedicalTeamFormParticipants',
        title: I18n.t('medicalTeam.addMedicalTeam'),
        passProps: {
          editable: props.editable,
        },
      },
      props.componentId
    );
  }, [props.componentId, props.editable]);

  const handleRemove = useCallback(
    (item) => {
      let obj = {
        userId: item.userId,
        isMedicalTeam: false,
      };

      dispatch(updateMedicalTeamParticipants(editingCaseId, obj));
    },
    [dispatch, editingCaseId]
  );

  return (
    <List
      medicalTeam={medicalTeam}
      onAdd={props.editable && addMedicalTeam}
      onSelect={null}
      onRemove={props.editable && handleRemove}
      scrollable={true}
    />
  );
});
